import { memo } from 'react';
import { Stack } from '@mui/material';

import { sectionToComponentMap } from '@occc-app/routes/Audience/components/sectionToComponentMap';

import { AudienceInfoFormContent } from './AudienceInfoFormContent';

import { DynamicAudienceSection } from '../constants';

type SectionRendererProps = {
  sectionKey: DynamicAudienceSection;
  clearFormField: (name: string) => void;
};

const SectionRenderer = memo((props: SectionRendererProps) => {
  const { sectionKey, clearFormField } = props;

  const Section = sectionToComponentMap[sectionKey];

  return <Section clearFormField={clearFormField} />;
});

export type FormContentProps = {
  clearFormField: (name: string) => void;
};

export const FormContent = memo((props: FormContentProps) => {
  return (
    <Stack spacing={1}>
      <AudienceInfoFormContent />
      <div>
        {Object.keys(sectionToComponentMap).map((sectionKey: DynamicAudienceSection) => (
          <SectionRenderer
            key={sectionKey}
            sectionKey={sectionKey}
            clearFormField={props.clearFormField}
          />
        ))}
      </div>
    </Stack>
  );
});
